import { CalendarDaysIcon, ClockIcon, UserGroupIcon } from "@heroicons/react/20/solid";
import { CogIcon } from "@/icons/outline";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const ArchivedCompany = ({}) => {
	return (
		<div
			className="block text-center bg-white"
			style={{ paddingTop: 120 }}
		>
			<div id="all-done">
				<div
					className="item item-circle bg-success"
					style={{ position: "relative", height: "8rem", width: "8rem", marginBottom: "2rem" }}
				>
					<ClockIcon
						style={{ position: "absolute", height: "6rem", color: "white", right: "1rem", top: "1rem" }}
					/>
				</div>
				<div
					className="item item-circle bg-primary"
					style={{
						position: "relative",
						height: "12rem",
						width: "12rem",
						marginLeft: "1rem",
						marginRight: "1rem",
					}}
				>
					<UserGroupIcon
						style={{ position: "absolute", height: "10rem", color: "white", right: "1rem", top: "1rem" }}
					/>
				</div>
				<div
					className="item item-circle bg-danger"
					style={{ position: "relative", height: "8rem", width: "8rem", marginBottom: "2rem" }}
				>
					<CalendarDaysIcon
						style={{ position: "absolute", height: "6rem", color: "white", right: "1rem", top: "1rem" }}
					/>
				</div>
				<div className="main">
					<h1 className="font-w700 text-center"></h1>
					<h4 className="text-center">This page is unaccessible whilst the company is archived.</h4>
					<p className="text-center">You can unarchive this company from the settings page.</p>
					<Link
						to="/organisation/settings"
						className="btn btn-primary"
						style={{ marginTop: "2rem" }}
					>
						<CogIcon style={{ height: "1.5em", float: "left", paddingRight: "5" }} />
						<div style={{ float: "left" }}>Go to Settings</div>
					</Link>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArchivedCompany);
